import { FormBase } from "core/components";

export default class TrackingCaseDocumentEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: "documentTypeId",
                    label: "TRACKING_CASE_DOCUMENT.EDIT.DOCUMENT_TYPE_LABEL",
                    placeholder: "TRACKING_CASE_DOCUMENT.EDIT.DOCUMENT_TYPE_PLACEHOLDER",
                    rules: "required|string"
                },
                {
                    name: "documentFormId",
                    label: "TRACKING_CASE_DOCUMENT.EDIT.DOCUMENT_FORM_LABEL",
                    placeholder: "TRACKING_CASE_DOCUMENT.EDIT.DOCUMENT_FORM_PLACEHOLDER",
                    rules: "string"
                },
                {
                    name: "validFrom",
                    label: "TRACKING_CASE_DOCUMENT.EDIT.VALID_FROM_LABEL",
                    placeholder: "TRACKING_CASE_DOCUMENT.EDIT.VALID_FROM_PLACEHOLDER",
                    rules: "required"
                },
                {
                    name: "validTo",
                    label: "TRACKING_CASE_DOCUMENT.EDIT.VALID_TO_LABEL",
                    placeholder: "TRACKING_CASE_DOCUMENT.EDIT.VALID_TO_PLACEHOLDER"
                },
                {
                    name: "name",
                    label: "TRACKING_CASE_DOCUMENT.EDIT.NAME_LABEL",
                    placeholder: "TRACKING_CASE_DOCUMENT.EDIT.NAME_PLACEHOLDER",
                    rules: "required|string"
                },
                {
                    name: "description",
                    label: "TRACKING_CASE_DOCUMENT.EDIT.DESCRIPTION_LABEL",
                    placeholder: "TRACKING_CASE_DOCUMENT.EDIT.DESCRIPTION_PLACEHOLDER",
                    rules: "string"
                }
            ],
        };
    }
}